import React, {Component} from 'react';
import { SectionTitleStyle } from '../styles/section_title_styles';


class SectionTitle extends Component {
  _isMounted = false
  constructor(props){
    super(props);
    const selection = props.data.nav_selection
    this.state = {
      selection_title: "Hotel Recommendations"
    }
    this.setTitle = this.setTitle.bind(this)
    this.setTitle(selection)
  }

  setTitle(selection){
    var selectionTitle = ""
    switch(selection){
      case "flights":
        selectionTitle = "Flight Recommendations";
        break;
      case "hotels":
        selectionTitle = "Hotel Recommendations";
        break;
      case "attractions":
        selectionTitle = "Attraction Recommendations";
        break;
      case "restaurants":
        selectionTitle = "Restaurant Recommendations";
        break;
      case "whole_journey":
        selectionTitle = "Whole Journey";
        break;
      default:
        selectionTitle = "Recommendations"
    }
    if(this._isMounted){
      this.setState(
        { selection_title: selectionTitle })
    }
  }

  UNSAFE_componentWillReceiveProps(props){
    this._isMounted = true;
    const selection = props.data.nav_selection
    this.setTitle(selection)
  }

  render(){
    return(
      <SectionTitleStyle> { this.state.selection_title } </SectionTitleStyle>
    )
  }

}

export default SectionTitle;
